if (!window.__missenceUiTabs) {
  window.__missenceUiTabs = true;
  const PANEL_SWITCH_DURATION_MS = 280;

  const getActiveComparisonPanel = (root) =>
    root.querySelector('[data-missence-ui-tab-panel].is-active:not([hidden])') ||
    root.querySelector('[data-missence-ui-tab-panel]:not([hidden])');

  const updateComparisonExpandButton = (root) => {
    const button = root.querySelector('[data-missence-comparison-expand]');
    const table = getActiveComparisonPanel(root)?.querySelector('.missence-ui-comparison-table');
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const isCollapsible = Boolean(table?.classList.contains('is-collapsible'));

    if (!button) return;

    button.hidden = !isMobile || !isCollapsible;
    if (!table || !isCollapsible) return;

    const isExpanded = table.dataset.expanded === 'true';
    const label = button.querySelector('[data-missence-comparison-expand-label]');
    const icon = button.querySelector('[data-missence-comparison-expand-icon]');
    button.setAttribute('aria-expanded', String(isExpanded));
    if (label) label.textContent = isExpanded ? button.dataset.lessLabel : button.dataset.moreLabel;
    if (icon) icon.textContent = isExpanded ? '−' : '+';
  };

  const updateComparisonScrollNav = (root) => {
    const panel = getActiveComparisonPanel(root);
    const nav = root.querySelector('[data-missence-comparison-scroll-nav]');
    const prevButton = nav?.querySelector('[data-missence-comparison-scroll-prev]');
    const nextButton = nav?.querySelector('[data-missence-comparison-scroll-next]');

    updateComparisonExpandButton(root);
    if (!panel || !nav || !prevButton || !nextButton) return;

    const maxScrollLeft = Math.max(0, panel.scrollWidth - panel.clientWidth);
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const hasOverflow = isMobile && maxScrollLeft > 4;

    nav.hidden = !hasOverflow;
    nav.classList.toggle('is-visible', hasOverflow);
    prevButton.disabled = !hasOverflow || panel.scrollLeft <= 4;
    nextButton.disabled = !hasOverflow || panel.scrollLeft >= maxScrollLeft - 4;
  };

  const initComparisonScrollNav = (root) => {
    const nav = root.querySelector('[data-missence-comparison-scroll-nav]');
    if (!nav || nav.dataset.initialized === 'true') return;

    const prevButton = nav.querySelector('[data-missence-comparison-scroll-prev]');
    const nextButton = nav.querySelector('[data-missence-comparison-scroll-next]');
    if (!prevButton || !nextButton) return;

    const scrollActivePanel = (direction) => {
      const panel = getActiveComparisonPanel(root);
      if (!panel) return;

      panel.scrollBy({
        left: direction * Math.max(180, panel.clientWidth * 0.75),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    };

    nav.dataset.initialized = 'true';
    prevButton.addEventListener('click', () => scrollActivePanel(-1));
    nextButton.addEventListener('click', () => scrollActivePanel(1));

    root.querySelectorAll('[data-missence-ui-tab-panel]').forEach((panel) => {
      panel.addEventListener('scroll', () => updateComparisonScrollNav(root), { passive: true });
    });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => updateComparisonScrollNav(root));
      resizeObserver.observe(root);
      root.querySelectorAll('[data-missence-ui-tab-panel]').forEach((panel) => resizeObserver.observe(panel));
    } else {
      window.addEventListener('resize', () => updateComparisonScrollNav(root));
    }

    updateComparisonScrollNav(root);
  };

  const initComparisonExpand = (root) => {
    const button = root.querySelector('[data-missence-comparison-expand]');
    if (!button || button.dataset.initialized === 'true') return;

    root.querySelectorAll('.missence-ui-comparison-table').forEach((table) => {
      const rowCount = table.querySelectorAll('.missence-ui-comparison-table__row:not(.missence-ui-comparison-table__row--head)').length;
      if (rowCount <= 7) return;

      table.classList.add('is-collapsible', 'is-collapsed');
      table.dataset.expanded = 'false';
    });

    button.dataset.initialized = 'true';
    button.addEventListener('click', () => {
      const table = getActiveComparisonPanel(root)?.querySelector('.missence-ui-comparison-table.is-collapsible');
      if (!table) return;

      const isExpanded = table.dataset.expanded === 'true';
      table.dataset.expanded = String(!isExpanded);
      table.classList.toggle('is-collapsed', isExpanded);
      updateComparisonExpandButton(root);
    });

    updateComparisonExpandButton(root);
  };

  const setActiveMissenceTab = (root, trigger, animate = false) => {
    if (!root || !trigger) return;

    const tabKey = trigger.getAttribute('data-missence-ui-tab-trigger');
    const panels = root.querySelector('.missence-comparison__panels');

    root.querySelectorAll('[data-missence-ui-tab-trigger]').forEach((button) => {
      const isActive = button === trigger;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', String(isActive));
    });

    root.querySelectorAll('[data-missence-ui-tab-panel]').forEach((panel) => {
      const isActive = panel.getAttribute('data-missence-ui-tab-panel') === tabKey;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    window.requestAnimationFrame(() => updateComparisonScrollNav(root));

    if (animate && panels) {
      panels.classList.remove('is-switching');
      window.requestAnimationFrame(() => {
        panels.classList.add('is-switching');
        window.setTimeout(() => {
          panels.classList.remove('is-switching');
        }, PANEL_SWITCH_DURATION_MS);
      });
    }
  };

  const initMissenceTabs = () => {
    document.querySelectorAll('[data-missence-ui-tabs-root]').forEach((root) => {
      const activeTrigger = root.querySelector('[data-missence-ui-tab-trigger].is-active');
      const firstTrigger = root.querySelector('[data-missence-ui-tab-trigger]');
      setActiveMissenceTab(root, activeTrigger || firstTrigger);
      initComparisonScrollNav(root);
      initComparisonExpand(root);
    });

    document.querySelectorAll('.missence-collection-products-section.is-pending').forEach((section) => {
      section.classList.remove('is-pending');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMissenceTabs);
  } else {
    initMissenceTabs();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-missence-ui-tab-trigger]');
    if (!trigger) return;

    const root = trigger.closest('[data-missence-ui-tabs-root]');
    if (!root) return;

    if (trigger.classList.contains('is-active')) return;

    setActiveMissenceTab(root, trigger, true);
  });
}
